import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import './styles.scss';

interface INotificationProps {
    content?: string | any;
    contentHtml?: string;
    type: NotificationType;
    visibility: boolean;
    setVisibility: Dispatch<SetStateAction<boolean>>;
    withoutClose?: boolean;
    extraClass?: string;
}

export enum NotificationType {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
}

const Notification: React.FC<INotificationProps> = ({
    content,
    contentHtml,
    type,
    visibility,
    setVisibility,
    withoutClose,
    extraClass = '',
}) => {
    const [visibilityClass, setvisibilityClass] = useState<string>(
        visibility ? 'show' : 'hide',
    );

    useEffect(() => {
        if (visibility) setvisibilityClass('show');
    }, [visibility]);

    const clickHandler = () => {
        const delay = 250;
        setvisibilityClass('slideOut');
        setTimeout(() => setVisibility(false), delay);
    };

    const noCloseClass = withoutClose ? 'no-close' : null;

    return (
        <div
            className={`notification-container u-mb-large ${type} ${visibilityClass} ${extraClass}`}
        >
            {contentHtml ? (
                <span
                    className={`notification-container__text ${noCloseClass}`}
                    dangerouslySetInnerHTML={{ __html: contentHtml }}
                ></span>
            ) : null}
            {content ? (
                <span
                    className={`notification-container__text ${noCloseClass}`}
                >
                    {content}
                </span>
            ) : null}

            {!withoutClose && (
                <span
                    className={'notification-container__img'}
                    onClick={clickHandler}
                >
                    <i
                        className='c-icon  c-icon--[semantic-close] c-icon--small'
                        role='img'
                        aria-hidden='true'
                    ></i>
                </span>
            )}
        </div>
    );
};

export default Notification;
